import React from 'react';
import './hero.css'
import Name from '../../components/Name/Name';
import Roles from '../../components/Role/roles';
import { Link } from 'react-scroll'
// import PaperCut from '../../components/Custom/PaperCut';
import TextSphere from '../../components/TextSphere';


const Hero = () => {
	return (
		<div className='hero' id='home'>
			<div className='heroIntro'>
				<div className='nameIntro'><span className="title">Hi, this is</span><Name /></div>
				<span className="headline">I'm a &nbsp;<Roles /></span>
				<button className='glowing-btn font-bai'>
					<Link to="about" spy={true} smooth={true} offset={-150} duration={500}>
						<span className='glowing-txt'>Ab<span className='faulty-letter'>o</span>ut <span className='faulty-letter'>M</span>e</span>
					</Link>
				</button>
			</div>
			<span className="mr-24">
				<TextSphere />
			</span>
			{/* <div className='mr-24 papercut'>
				<PaperCut value={"DEV"} />
				<PaperCut value={"ELO"} />
				<PaperCut value={"PER"} />
			</div> */}
		</div>
	);
};

export default Hero;
